// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zvhwjpeeapujvuudfdps.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2aHdqcGVlYXB1anZ1dWRmZHBzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEyMDk5ODQsImV4cCI6MjA1Njc4NTk4NH0.1IL2u7UbWNZJ2EHdXnHBSoxNuETE0s0BebYLDiZXzN4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);